import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReportsIndexScreen } from '@/features/accounting-reports/reports-index-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the reports landing — definition, guard, render, nothing
 * else (AGENTS.md: a route file is a shell). The six report screens are
 * siblings, not children, so this renders the landing directly.
 */
export const Route = createFileRoute('/_authenticated/accounting/reports/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: ReportsIndexScreen,
})
